export default {
  orderStatus: {
    0: 'Sie haben die Bestellung aufgegeben, bitte warten Sie, bis der Startseite die Bestellung erhält',
    23: 'Der Startseite hat die Bestellung erhalten und kontaktiert den Händler',
    22: 'Ihre Ware wurde bestellt, Transaktionsnummer: ',
    5: 'Der Händler hat versandt, Versandart: ',
    10: 'Ihr Produkt ist im von Acbuy bestimmten Lager eingetroffen',
    16: 'Ihre Rückgabe wurde übermittelt. Bitte warten Sie, bis Ihr Agent sie bearbeitet',
    17: 'Ihre Umtauschanfrage wurde übermittelt. Bitte warten Sie, bis Ihr Agent sie bearbeitet',
    buyerReturn:
      'Der Agent hat eine Rückgabe- aufgrund von Kundenbedürfnissen, Artikelsrisiken usw. eingereicht. Bitte warten Sie auf die Bearbeitung',
    buyerReplace:
      'Der Agent hat eine Umtauschanfrage aufgrund von Kundenbedürfnissen, Artikelsrisiken usw. eingereicht. Bitte warten Sie auf die Bearbeitung',
    20: 'Die Bestellung wurde zurückgesendet',
    beenReturned: 'Rückerstattungen prüfen >',
    30: 'Ihr Artikel wurde versandt, sehen Sie sich das Paket hier an: ',
    43: 'Ihre Rücksendeanfrage wurde storniert',
    44: 'Ihre Umtauschanfrage wurde storniert',
    49: 'Lagerverlängerung unbezahlt. Artikel gilt als freiwillig aufgegeben.',
  },
  expressNo: 'Sendungsverfolgungsnummer: ',
}
